import GavelIcon from '@mui/icons-material/Gavel';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import SecurityIcon from '@mui/icons-material/Security';
import InboxIcon from '@mui/icons-material/Inbox';
import GroupsIcon from '@mui/icons-material/Groups';

import reportCategories, { ReportCategories } from '../../../constants/reportCategories';
import reportTypes, { SelectableReportTypes } from '../../../constants/reportTypes';
import palette from '../../../theme/palette';

export const categoryIcons: Record<ReportCategories, React.ElementType> = {
  [reportCategories.REGULATORY]: GavelIcon,
  [reportCategories.SCENARIO]: QueryStatsIcon,
  [reportCategories.RISK]: SecurityIcon,
  [reportCategories.REQUESTS_PINGS_CASES]: InboxIcon,
  [reportCategories.ENTITIES]: GroupsIcon,
};

export const categoryColors: Record<ReportCategories, string> = {
  [reportCategories.REGULATORY]: palette.blue.main,
  [reportCategories.SCENARIO]: palette.secondary.main,
  [reportCategories.RISK]: palette.red.main,
  [reportCategories.REQUESTS_PINGS_CASES]: palette.orange.main,
  [reportCategories.ENTITIES]: palette.yellow.main,
};

export const categoryNames: Record<ReportCategories, string> = {
  [reportCategories.REGULATORY]: 'Regulatory',
  [reportCategories.SCENARIO]: 'Scenario',
  [reportCategories.RISK]: 'Risk',
  [reportCategories.REQUESTS_PINGS_CASES]: 'Requests, Pings & Cases',
  [reportCategories.ENTITIES]: 'Entities',
};

export const categoryDescriptions: Record<ReportCategories, string> = {
  [reportCategories.REGULATORY]: 'Statutory filings and population-wide PEP, sanction & adverse media screening results',
  [reportCategories.SCENARIO]: 'Backtest TM rule thresholds, analyse hit rates, and audit rule configurations over time',
  [reportCategories.RISK]: 'Risk score and risk class distribution across the entity portfolio',
  [reportCategories.REQUESTS_PINGS_CASES]: 'Transaction-level request data, AML alert (ping) lists, and investigation case exports',
  [reportCategories.ENTITIES]: 'Entity registry snapshots, per-entity transaction volumes, group lifecycle timing, and business usage patterns',
};

export interface ReportCategoryDefinition {
  id: ReportCategories;
  reportTypes: SelectableReportTypes[];
}

export const reportCategoriesDefinition: ReportCategoryDefinition[] = [
  {
    id: reportCategories.REGULATORY,
    reportTypes: [
      reportTypes.PEP_SANCTION_HITS_THRESHOLD_VARIATION,
      reportTypes.PORTFOLIO_SCREENING_REPORT,
    ],
  },
  {
    id: reportCategories.SCENARIO,
    reportTypes: [
      reportTypes.RULE_THRESHOLD_VARIATION,
      reportTypes.RULE_STATISTICS,
      reportTypes.RULE_OVERVIEW,
    ],
  },
  {
    id: reportCategories.RISK,
    reportTypes: [
      reportTypes.KRI_REPORT,
    ],
  },
  {
    id: reportCategories.REQUESTS_PINGS_CASES,
    reportTypes: [
      reportTypes.REQUEST_OVERVIEW,
      reportTypes.EXTENDED_TRANSACTIONS,
      reportTypes.PING_OVERVIEW,
      reportTypes.CASE_OVERVIEW,
      reportTypes.CASE_STATUS_HISTORY_REPORT,
    ],
  },
  {
    id: reportCategories.ENTITIES,
    reportTypes: [
      reportTypes.GROUP_DURATION,
      reportTypes.ENTITY_TRANSACTIONS,
      reportTypes.ENTITY_OVERVIEW,
      reportTypes.BUSINESS_USAGE_REPORT,
      reportTypes.ACCOUNT_FIRST_INITIATOR,
    ],
  },
];
